export default __webpack_public_path__ + "static/media/training_battle_preview.7435a624.png";